<div class='width-1100'>

    <mat-card id='table-header'>
        <mat-toolbar class="toolbar-top">

            <div class='title'>
                <mat-icon>wallpaper</mat-icon>
                <div> Banners APP</div>
            </div>

            <div flex justify-content='flex-end' fxLayoutAlign="end">
                <a mat-button (click)="openDialog()" style='width:60px;'>
                    <mat-icon color='primary'>add_circle_outline</mat-icon>
                </a>
            </div>

        </mat-toolbar>
    </mat-card>

    <mat-card>


        <!-- TABLE -->
        <mat-table [dataSource]="sponsorsDataSource" style='margin: 0 0 10px 0;'>

            <!-- image -->
            <ng-container matColumnDef="image">
                <mat-header-cell *matHeaderCellDef>Imagem</mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <ng-container>
                        <img class='banner_image' [src]='element.image'>
                    </ng-container>
                </mat-cell>
            </ng-container>

            <!-- Link Column -->
            <ng-container matColumnDef="link">
                <mat-header-cell *matHeaderCellDef> Link </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{ element.link }}
                </mat-cell>
            </ng-container>

            <!-- delete Column -->
            <ng-container matColumnDef="delete">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <a mat-button (click)='removeBannerSponsor(element)' style='background-color: whitesmoke;'>
                        <mat-icon style='font-size:1.5em; color:rgba(247, 10, 10, 0.7)'>delete_outline
                        </mat-icon>
                    </a>
                </mat-cell>
            </ng-container>

            <!-- Header -->
            <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedSponsorColumns">
            </mat-header-row>

            <!-- Row -->
            <mat-row *matRowDef="let row; columns: displayedSponsorColumns;">
            </mat-row>

        </mat-table>
        <!-- END TABLE -->


    </mat-card>

</div>